import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "sort-down",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M18.0001 8.24991C18.3034 8.24992 18.5773 8.43259 18.6934 8.7128C18.8095 8.99301 18.7448 9.3157 18.5303 9.53018L12.5303 15.5302C12.2374 15.8231 11.7627 15.8231 11.4698 15.5302L5.4698 9.53018C5.25533 9.3157 5.19067 8.99303 5.30671 8.7128C5.42281 8.43259 5.69675 8.24991 6.00007 8.24991H18.0001Z",
			fill: "currentColor"
		})
	})
});
export default SvgSortDown;
